<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { typeHasMonolingualTitle, type SerializedEntity } from '#entities/lib/entities'
  import SourceLogo from '#inventory/components/entity_source_logo.svelte'
  import type { Url } from '#server/types/common'
  import BirthAndDeathDates from './birth_and_death_dates.svelte'

  const {
    entity,
    hasSourceLogo = false,
    href,
    hasLinkTitle = false,
  }: {
    entity: SerializedEntity
    hasSourceLogo?: boolean
    href?: Url
    hasLinkTitle?: boolean
  } = $props()

  const uri = $derived(entity.uri)
  const claims = $derived(entity.claims)
  const label = $derived(typeHasMonolingualTitle(entity.type) ? (entity.claims['wdt:P1476']?.[0] || entity.label) : entity.label)
  // Do not display subtitles for other types (typically works)
  // as it might result in subtitles in different languages to be displayed
  // Example: /entity/wd:Q123676064
  const subtitle = $derived(typeHasMonolingualTitle(entity.type) ? claims['wdt:P1680']?.[0] : null)
</script>

<h2>
  {#if hasLinkTitle}
    <Link
      url={href || `/entity/${uri}`}
      text={label}
      dark={true}
    />
  {:else}
    {label}
  {/if}
  {#if hasSourceLogo}
    <SourceLogo {entity} />
  {/if}
</h2>
<BirthAndDeathDates {entity} />
{#if subtitle}
  <div class="subtitle">
    {subtitle}
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  h2{
    margin: 0;
    :global(.link-text){
      @include serif;
    }
  }
  .subtitle{
    margin-block-end: 0.3em;
    color: #444;
  }
</style>
